import { parseISO, format } from 'date-fns'

// Helper to convert Date to YYYY-MM-DD
export function toDateString(date: Date): string {
  return format(date, 'yyyy-MM-dd')
}

// Helper to parse YYYY-MM-DD to Date (start of day UTC)
export function fromDateString(dateStr: string): Date {
  return parseISO(dateStr)
}

export function getEndOfLastTaxYear(date: Date) {
  const year = date.getFullYear()
  return toDateString(new Date(year - 1, 3, 5))
}
